import style from './ErrorMessage.module.scss'

const ErrorMessage = ({ message }) => {
  return <span className={style.errorMessage}>{message}</span>
}

export default ErrorMessage
